import PropTypes from 'prop-types'
import React, { Component } from 'react'

class ErrorModal extends Component {
  show() {
    global.jQuery(this.modal).modal()
  }

  render() {
    return (
      <div ref={(ref) => { this.modal = ref }} className="modal fade" id="myModal" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Descubra seu futuro</h4>
              <button type="button" className="close" data-dismiss="modal">&times;</button>
            </div>
            <div className="modal-body">
              <p id="error">
                {this.props.message}
              </p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" data-dismiss="modal">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ErrorModal.propTypes = {
  message: PropTypes.string.isRequired,
}

export default ErrorModal



// WEBPACK FOOTER //
// ./src/components/application/ErrorModal.js